export const sliderItems = [
{
    image: 'https://img9.hkrtcdn.com/19799/bnr_1979878_o.jpg',
    title: 'MUSCLE BLAZE',
    desc: "This is India's best protein!! Recommended by Best atheletes.",
    bg: "#ddd6fe"
},
{
    image: 'https://img9.hkrtcdn.com/19798/bnr_1979778_o.jpg',
    title: 'OPTIMUM NUTRITION',
    desc: "This is India's best protein!! Recommended by Best atheletes.",
    bg: "#f5d0fe"
},
{
    image: 'https://img7.hkrtcdn.com/19806/bnr_1980526_o.jpg',
    title: 'MUSCLETECH',
    desc: "This is India's best protein!! Recommended by Best atheletes.",
    bg: "#fecdd3"
},
]

export const categories = [
    {
      id: 1,
      img: "https://content.optimumnutrition.com/i/on/homepage-image-protein?w=400",
      title: "WHEY PROTIEN",
      cat: "whey"
    },
    {
      id: 2,
      img: "https://img2.hkrtcdn.com/13489/prd_1348821-MuscleBlaze-PRE-Workout-200-0.22-lb-Fruit-Splash_o.jpg",
      title: "PRE WORKOUT",
      cat: "preworkout"
    },
    {
      id: 3,
      img: "https://images.pexels.com/photos/3683116/pexels-photo-3683116.jpeg",
      title: "VITAMINS & SUPPLEMENTS",
      cat: "vitamins"
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
    },
    {
      id:2,
      img:"https://cdn.shopify.com/s/files/1/0101/4832/products/Angela_Natural_Tee.png?v=1606780388",
    },
    {
      id:3,
      img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
    },
    {
      id:4,
      img:"https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
    },
    {
      id:5,
      img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    },
    {
      id:6,
      img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
    },
    {
      id:7,
      img:"https://www.vintageindustries.nl/download_front/qympzk1762/2217_Arrow_Jacket_Forest.png",
    },
    {
      id:8,
      img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
  ]